// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { DollarCircleOutlined } from '@ant-design/icons';

// type
import { NavItemType } from 'types/menu';
import { UserProfile } from 'types/auth';

// icons
const icons = { DollarCircleOutlined };

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

function GetSubscriptionMenuItems(user: UserProfile): NavItemType[] {

  function GetMyPriceListItems(): NavItemType[] {
    if (user?.newDealerStatus !== 'C') {
      return [
        {
          id: 'newdealer-pricelist-inquiry',
          title: <FormattedMessage id="my-pricelists-newdealer" />,
          type: 'item',
          url: '/newdealer/pricelist/list'
        }
      ]
    }
    else if (!!!user?.isPriceListSubscriptionApproved ?? false) {
      return [
        {
          id: 'pricelist-list-pre-activation',
          title: <FormattedMessage id="my-pricelists-preactivation" />,
          type: 'item',
          url: '/subscriptions/pricelist/list'
        }
      ];
    } else {
      return [
        {
          id: 'pricelist-list-post-activation',
          title: <FormattedMessage id="my-pricelists" />,
          type: 'item',
          url: '/subscriptions/pricelist/list'
        }
      ]
    }
  }

  return [
    {
      id: 'group-subscriptions',
      title: <FormattedMessage id="subscriptions" />,
      breadcrumbs: false,
      type: 'group',
      children: [
        {
          id: 'pricelists',
          title: <FormattedMessage id="pricelists" />,
          type: 'collapse',
          icon: icons.DollarCircleOutlined,
          children: GetMyPriceListItems()
        }
      ]
    }
  ]
};

export default GetSubscriptionMenuItems;